import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  blog: {
    id: 'sellpage.link.blog',
    defaultMessage: 'Blog',
  },
  explore: {
    id: 'sellpage.link.explore',
    defaultMessage: 'Explore studios',
  },
  features: {
    id: 'sellpage.link.features',
    defaultMessage: 'How it works',
  },
  locations: {
    id: 'sellpage.link.locations',
    defaultMessage: 'Locations',
  },
  pricing: {
    id: 'sellpage.link.pricing',
    defaultMessage: 'Pricing',
  },
  navMore: {
    id: 'sellpage.more',
    defaultMessage: 'More',
  },
});
